import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { lessonConst } from '.';

interface ILessonState {
  status: lessonConst.LessonStatus | null;
  paymentModal: boolean;
  progress: number;
  bookResource?: string | null;
}

const initialState: ILessonState = {
  status: null,
  paymentModal: false,
  progress: 0,
  bookResource: null
};

const lessonSlice = createSlice({
  name: 'lesson',
  initialState,
  reducers: {
    setLessonStatus: (state, action: PayloadAction<lessonConst.LessonStatus>) => {
      state.status = action.payload;
    },
    resetLessonStatus: state => {
      state.status = null;
    },
    setPaymentModal: (state, action: PayloadAction<boolean>) => {
      state.paymentModal = action.payload;
    },
    setProgress: (state, action: PayloadAction<number>) => {
      state.progress = action.payload;
    },
    setBookResource: (state, action: PayloadAction<string>) => {
      state.bookResource = action.payload;
    }
  }
});

export const { setLessonStatus, resetLessonStatus, setPaymentModal, setProgress, setBookResource } =
  lessonSlice.actions;
export const lessonReducer = lessonSlice.reducer;
